import { defaultTheme } from "react-admin";

// Breakpoints other than mobile have default values
// They need to be redefined from scratch per the docs
// https://mui.com/material-ui/customization/breakpoints/#custom-breakpoints
const breakpoints = {
	xs: 0,
	mobile: 376,
	sm: 600,
	md: 960,
	lg: 1280,
	xl: 1920,
};

export const NyuTheme = {
	...defaultTheme,
	palette: {
		primary: {
			main: "#580F8B",
		},
		caption: {
			main: "#595959",
		},
		neutral: {
			main: "#EBEBEB",
		},
	},
	components: {
		...defaultTheme.components,
		MuiTableCell: {
			styleOverrides: {
				head: {
					fontWeight: "bold",
				},
				root: {
					"&. MuiTypography-body1": {
						"@media (max-width: 375px)": {
							overflowWrap: "anywhere",
						},
					},
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					"@media (max-width: 600px)": {
						padding: 3,
					},
				},
			},
		},
		RaDatagrid: {
			styleOverrides: {
				root: {
					"& .RaDatagrid-headerCell": {
						backgroundColor: "#E4E8F0",
					},
				},
			},
		},
		RaShow: {
			styleOverrides: {
				root: {
					"& .RaShow-main": {
						marginBottom: 8,
						"@media (max-width: 375px)": {
							marginBottom: 0,
						},
					},
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					"&.MuiTypography-body2": {
						overflowWrap: "anywhere",
					},
					"&.MuiTypography-h6": {
						"@media (max-width: 375px)": {
							overflowWrap: "anywhere",
						},
					},
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					"&.MuiDrawer-paper": {
						backgroundColor: "#FFF",
					},
					"&.MuiPaper-elevation1": {
						"@media (max-width: 600px)": {
							boxShadow: "none",
						},
					},
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					"@media (max-width: 375px)": {
						maxWidth: "250px",
					},
				},
			},
		},
	},
	typography: {
		...defaultTheme.typography,
		h1: {
			fontSize: 40,
			"@media (max-width: 375px)": {
				fontSize: 22,
			},
		},
		h2: {
			fontSize: 32,
			"@media (max-width: 375px)": {
				fontSize: 20,
			},
		},
	},
	breakpoints: {
		values: breakpoints,
	},
};

declare module "@mui/material/styles" {
	interface BreakpointOverrides {
		xs: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		mobile: true;
	}
}

declare module "@mui/material/Button" {
	interface ButtonPropsColorOverrides {
		neutral: true;
	}
}
